import { withByosImgixServerSign } from '@air/component-imgix-image';

import { type EditUploadContentType } from '../types';
import { isImageEditUploadContentType } from './uploadMimeTypes';

/**
 * Fetches a URL and wraps the response body in a `File`, normalizing the
 * content type to an accepted edit-upload image MIME type (defaulting to PNG).
 * Video responses fall back to PNG — this helper is for image-node flows only.
 */
export const fetchAsFile = async (
  url: string,
  fileName: string,
): Promise<{ file: File; contentType: EditUploadContentType }> => {
  const response = await fetch(withByosImgixServerSign(url));

  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}`);
  }

  const blob = await response.blob();
  const contentType: EditUploadContentType = isImageEditUploadContentType(blob.type) ? blob.type : 'image/png';

  return { contentType, file: new File([blob], fileName, { type: contentType }) };
};
